import { useAuth } from '@hooks';
import LinkButton from '../../app-components/link/linkButton.jsx';

const NotLoggedIn = () => {
  const { login } = useAuth();
  return (
    <div className='padding-top-3 padding-left-4'>
      <p>
        You are currently not signed in. To sign in,{' '}
        <LinkButton onClick={() => login()} title='click here' content='click here' /> or use the link on the Navigation
        Menu.
      </p>
    </div>
  );
};

export default NotLoggedIn;
